import { Operation } from "./Operation";
import { OperationContext } from "../OperationContext";

export class GetContentControlTexts implements Operation<string[]> {
  async commit(context: OperationContext): Promise<string[]> {
    const contentControls = context.document.contentControls;
    contentControls.load("items");
    await context.sync();

    if (contentControls.items.length === 0) {
      return [];
    }

    const uniqueTexts: string[] = [];
    for (const contentControl of contentControls.items) {
      contentControl.load("text");
      await context.sync();
      uniqueTexts.push(contentControl.text);
    }

    return uniqueTexts;
  }

  merge(_: Operation<unknown>) {
    if (_ instanceof GetContentControlTexts) {
      return this;
    }
    return undefined;
  }
}
